import React, { Component } from 'react';
import * as Utils from '../components/Utils';
import LoadingSpinner from '../components/LoadingSpinner'
import Moment from 'moment'
import MomentTz from 'moment-timezone'
import ReactTooltip from "react-tooltip";
import {
    Subheader,
    ListItem,
    Collapse,
    Divider,
    Button,
    List,
    Grid,
    Cell,
    Chip } from 'react-md';
import InfoIcon from "../images/svg/info-cirlce.svg"
import { ProgressBar, Table } from 'react-bootstrap';
import circle from '../images/png/circle.png';
import Properties from '../components/Properties';
import { AppProperties } from '../common/functions';


var timeZone = 'America/New_York';

const quizDummyData = [
    {
    "quiz_id": 1,
    "quiz_name": "Java 101",
    "start_date": "05/02/2018",
    "start_time": "00:00:00",
    "end_date": "05/10/2018",
    "end_time": "00:00:00",
    "completion_percentage":100,
    "time_elapsed":"32:12:00",
    "is_finish":1,
    "completed_date":"05/08/2018",
    "rank":1,
    "section_name":"",
    "course_name":"",
    "category":[
        {"name":"Wheel1","value":90},
        {"name":"Wheel2","value":94},
        {"name":"Wheel3","value":87}
    ]
    }

];

const purple = "#005200",
      red = "#D50000",
      yellow = "#2239ab",
      blue = "#0073E5",
      darkGray ="#757575";

export default class StudentDashboard extends Component {
    appProperties = AppProperties();
    constructor(props)
    {
        super(props);
        this.state = {
            processedData: [],
            toggle: [],
            parent: true,
            selectedItem: quizDummyData[0],
            timeStatus: "hidden",
            loading: false,
            noDataError:false,
            noDataErrorStr:"",
            selectedCourseID: this.props.selectedCourseID
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.selectedCourseID !== prevProps.selectedCourseID) {
            this.setState({noDataError: false, noDataErrorStr:''})
            this.UNSAFE_componentWillMount();
          }
      }

    UNSAFE_componentWillMount()
    {
        const noCoursesText = <div style={{width:'81%',textAlign:'center',position: "absolute",top: "40%"}}><h1 style={{color:"#BB0000",fontSize:"xx-large"}}>
        {this.appProperties.schoolMode?"Don't see your Standard?":"Enroll in a course to start seeing assignments scheduled by your Instructor."}</h1><br/><a href='settings'><Button  primary  raised className="buttonColour" flat styel={{align:"center",minWidth:"100%"}}>Click here to enroll</Button></a> </div>
        
        if (this.props.selectedCourseID < 0) {
            this.setState({noDataError: true, noDataErrorStr:noCoursesText})
            return
        };

        this.setState({loading:true})
        var quizData = [];
        const payload = {
            course_id: this.props.selectedCourseID,
            includeLTI: true,
        }
        let responsePromise = this.props.apiService({method: 'post',
        url: '/getQuizStudentDashboard',
        data: payload});
        responsePromise.then(res => {
            console.log("getQuizStudentDashboard res.data.data.",res.data.data);
            if(res.data.data.data !== null){
                quizData = res.data.data.data;
                timeZone = res.data.data.time_zone;

                this.prepareData(quizData)
            }else if(res.data.data.flag || res.data.data.flag !== ""){
                if(res.data.data.flag !== "OK"){
                    let errorString =""
                    if(res.data.data.flag === "No Assignments yet"){
                        errorString = <div style={{textAlign:'center',width:'81%',position: "absolute",top: "40%"}}><h1 style={{color:"#BB0000",fontSize:"x-large"}}>
                            {this.appProperties.schoolMode?"Don't see your Standard?":<div>
                            <div className='mb-2'>Currently, there are no assignments scheduled for this course.</div>
                            {
                                this.appProperties?.isLTIStudent ? 
                                    <div>For your course, you may need to access your assignments through Carmen.</div>
                                : null
                            }
                            </div>}</h1> </div>
                    }

                    if(res.data.data.flag === "Enroll for one or more Sections in Settings page"){
                        errorString = <div style={{width:'81%',textAlign:'center',position: "absolute",top: "40%"}}><h1 style={{color:"#BB0000",fontSize:"xx-large"}}>
                            {this.appProperties.schoolMode?"Don't see your Standard?":"Enroll in a course to start seeing assignments scheduled by your Instructor."}</h1><br/><a href='settings'><Button  primary  raised className="buttonColour" flat styel={{align:"center",minWidth:"100%"}}>Click here to enroll</Button></a> </div>
                    }

                    this.setState(
                        {loading:false,
                        noDataError:true,
                        noDataErrorStr:errorString
                    });
                }
            }
            
        }).catch(error => {
            console.error("Error when getting Student Dashboard Data",error)
          });;

    }

    prepareData(quizData){
        var pastQuiz = [], upcomingQuiz = [], currentQuiz = [], toggle = [];
        var processedData = [];
        for(var i=0;i<quizData.length;i++){
            toggle[i]=true;
            var currentItem = quizData[i];
            currentItem.indexer=i;


            var start_date = MomentTz.tz(currentItem.start_date+" "+currentItem.start_time,'DD/MM/YYYY hh:mm:ss',timeZone).toDate();
            var end_date = MomentTz.tz(currentItem.end_date+" "+currentItem.end_time,'DD/MM/YYYY hh:mm:ss',timeZone).toDate();

          

            currentItem.resumeBtn = false;

            currentItem.timeColor = this.getRankColor(currentItem.rank);
            currentItem.takeQuiz = false;
            currentItem.sortStartDate = MomentTz.tz(currentItem.start_date+" "+currentItem.start_time,'DD/MM/YYYY hh:mm:ss',timeZone).toDate()
            currentItem.sortEndDate = MomentTz.tz(currentItem.end_date+" "+currentItem.end_time,'DD/MM/YYYY hh:mm:ss',timeZone).toDate();
            //currentItem.sortStartDate = Moment(currentItem.start_date,'DD/MM/YYYY').format("YYYY/MM/DD")
            //currentItem.sortEndDate = Moment(currentItem.end_date,'DD/MM/YYYY').format("YYYY/MM/DD")
            if(currentItem.is_finish===1){
                currentItem.status="Completed";
                currentItem.statusColor = purple;
                currentItem.displayDate = "Completion Date:" + Moment(currentItem.completed_date,'DD/MM/YYYY').format("MM/DD/YYYY");
                pastQuiz.push(currentItem);
            }else{
                //var currentTimestamp = currentItem.current_time;
                var today = new Date();
                if(today.getTime()<start_date.getTime()){
                    currentItem.status = "Opens in "+Utils.calculateDuration(today,start_date);
                    currentItem.statusColor = blue;
                    currentItem.takeQuiz = false;
                    currentItem.displayDate = "Starting Date:" + Moment(currentItem.start_date,'DD/MM/YYYY').format("MM/DD/YYYY");
                   
                    upcomingQuiz.push(currentItem);
                }else if(today.getTime()>start_date.getTime() && today.getTime()<end_date.getTime()){
                    //console.log("end_date  =",end_date);
                    var tempEndDateMunis2days = new Date(end_date);
                    tempEndDateMunis2days.setDate(tempEndDateMunis2days.getDate()-2);
                   if(tempEndDateMunis2days.getTime() <= today.getTime()){
                        currentItem.statusColor = red;
                    }else{
                        currentItem.statusColor = yellow;
                    }
                    currentItem.status = "Due in "+Utils.calculateDuration(end_date,today);
                    
                    currentItem.takeQuiz = true;
                    currentItem.displayDate = "Due Date:"+Moment(currentItem.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")
                    if(currentItem.finalscore_start_time !== undefined && currentItem.finalscore_start_time !== null
                        && currentItem.finalscore_start_time.length > 0){
                        currentItem.resumeBtn  = true;
                        //console.log("currentItem.resumeBtn",currentItem.resumeBtn);
                    }
                    currentQuiz.push(currentItem);
                }else{
                    currentItem.status = "Closed";
                    currentItem.statusColor = red;
                    currentItem.displayDate = "Closed Date:"+Moment(currentItem.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")
                    pastQuiz.push(currentItem);
                }
            }
        }
        //currentQuiz.sort((a,b) => (a.sortEndDate > b.sortEndDate) ? 1 : ((b.sortEndDate >  a.sortEndDate) ? -1 : 0)); 
        //upcomingQuiz.sort((a,b) => ((a.sortStartDate) > b.sortStartDate) ? 1 : ((b.sortStartDate > a.sortStartDate) ? -1 : 0)); 
       // pastQuiz.sort((a,b) => ((a.sortStartDate) > b.sortStartDate) ? -1 : ((b.sortStartDate > a.sortStartDate) ? 1 : 0)); 
        
        currentQuiz.sort(function(a,b){
            a = new Date(a.sortEndDate)
            b = new Date(b.sortEndDate)
            return a>b ? 1 : a<b ? -1 : 0;
        });
        upcomingQuiz.sort(function(a,b){
            a = new Date(a.sortStartDate)
            b = new Date(b.sortStartDate)
            return a>b ? 1 : a<b ? -1 : 0;
        });
        pastQuiz.sort(function(a,b){
            a = new Date(a.sortEndDate)
            b = new Date(b.sortEndDate)
            return a>b ? -1 : a<b ? 1 : 0;
        });
        processedData = [{"title":"Current","data":currentQuiz},
                        {"title":"Up Next","data":upcomingQuiz},
                        {"title":"Past","data":pastQuiz}];

        this.setState({
            toggle: toggle,
            processedData: processedData,
            loading: false
        });
    }

    getRankColor(rank) {
        if (rank === 1) {
            return yellow;
        }
        else if (rank === 2) {
            return purple;
        }
        else {
            return red;
        }
    }

    getTimeColor(sec_num){
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        //var seconds = sec_num - (hours * 3600) - (minutes * 60);
        
        if (minutes <= 15) {
            return purple;
        }
        else if (minutes > 15) {
            return yellow;
        }
        else {
            return red;
        }

    }


    toggleAccordian(index){
        var toggle =  this.state.toggle;
        toggle[index] = !toggle[index];
        this.setState({toggle:toggle});
    };

    toggleViewMore(item){
        //console.log("toggleViewMore = ",item);
        item.timeStatus="hidden";
        this.setState(
            {parent:!this.state.parent,
        selectedItem:item});
    };

    showTimeStatus(rank){
        var popup = document.getElementById("timeStatus");
        this.changeStatus(rank,popup)
    }

    changeStatus(rank,popup)
    {
        popup.style.visibility = popup.style.visibility==="visible"?"hidden":"visible";
        if(rank===1){
            popup.innerText="You're Superfast!"
        }else if(rank===2){
            popup.innerText="You're doing fine"
        }else{
            popup.innerText="You need to speed up"
        }
    }

    getStatus(rank) {
        var rankText = ""

        if(rank === 1){
            rankText="You're Superfast!"
        }else if(rank === 2){
            rankText="You're doing fine"
        }else{
            rankText="You need to speed up"
        }

        return rankText
    }

    getResumePracticeFlag(item) {
        let l = item.scores ? item.scores.length : 0
        if (l === 0) return false
        let lastScore = item.scores[l - 1]
        if (lastScore.is_finish !== 1 && lastScore.practice_number > 0) return true
        return false
    }

    showTimeStatusArray(item){
        var popup = document.getElementById("timeStatus"+item.indexer);
        this.changeStatus(item.rank,popup)
    }

    takeQuizDirect(quiz_id,quiz_name, course_id, section_id,quiz_type){
        // this.props.handleRoute('/takequiz/'+quiz_id + '/' + course_id + '/' + section_id +'/'+quiz_name +'/'+quiz_type);
        let url = `/takequiz?quiz_id=${quiz_id}&course_id=${course_id}&section_id=${section_id}&quiz_name=${quiz_name}&quiz_type=${quiz_type}`
        this.props.handleRoute(url)
    }

    render(){
        var styleArray=[ "warning","success","danger", "info"];
        const selectedItem= this.state.selectedItem;

        //Show Loading When Contents are Being Loaded
        if(this.state.loading)
        return <LoadingSpinner></LoadingSpinner>;

        if(this.state.noDataError)
        return this.state.noDataErrorStr

        if(this.state.parent){
        return (
            <div>
            <h1 className = "md-text--theme-primary" style = {{textAlign:'center', fontSize: "1.5rem"}}>Assignment List</h1>
            <center>
            <List style = {{maxWidth: '700px'}}>
                {this.state.processedData.map((pdata, pindex)=> <div key={pindex}>
                <Subheader style={{fontSize:"0.9rem"}}primary primaryText={pdata.title}/>
                {pdata.data.map((item,index)=> <div key={item.indexer}>
                    <ListItem threeLines primaryText={item.quiz_name} secondaryText= {(this.appProperties.schoolMode?"Standard Name: ":"Course Name: ") + item.course_name + "\n" + 
                        (item.is_finish===1?"Completion Date:"+item.completed_date:"Start Date:"+Moment(item.start_date,'DD/MM/YYYY').format("MM/DD/YYYY")+" Due Date:"+Moment(item.end_date,'DD/MM/YYYY').format("MM/DD/YYYY"))}
                     onClick={()=>this.toggleAccordian(item.indexer)} style={{background:this.state.toggle[item.indexer]?"#F5F5F5":"#C3C3C3"}}
                     rightIcon={
                        <React.Fragment>
                            <Chip labelStyle={{color:"white"}} label={item.status} style={{background:item.statusColor}} removable>
                                <img style={{borderRadius: "50%",margin:"6px",right:"6px",width:"10px"}}  alt="" src={circle} ></img>
                            </Chip>
                            {item.allow_practice && item.is_finish === 1 && (item.status === "Completed" || item.status === "Closed") ? 
                            <React.Fragment>
                                <ReactTooltip  
                                    id="practice"
                                    multiline={true}
                                    place="top"
                                    className='tool-tip'
                                    effect="float"
                                />
                                <Chip data-tip={"Retake any of the categories in the assignment for practice. You can compare your performance each time your practice."}
                                    data-for="practice" labelStyle={{color:"white"}} label={"Practice"} style={{background:"#fc543e", marginLeft:"4px"}} removable>
                                    <img style={{borderRadius: "50%",margin:"6px",right:"6px",width:"10px"}}  alt="" src={circle} ></img>
                                </Chip>
                                </React.Fragment>
                            : null}
                        </React.Fragment>
                     
                     }
                     ></ListItem>
                       <Collapse collapsed={this.state.toggle[item.indexer]}>
                       <div style={{background:"#F2F2F2"}} className="md-divider-border md-divider-border--top md-divider-border--right md-divider-border--bottom md-divider-border--left">
                       <Grid>
                            <p style={{fontSize:"14px",color:"#555", margin:"1rem"}}>
                            <img src={InfoIcon} width='15' className='mr-1'></img>
                            Your credit for this assignment is on line #1, every other practice attempts are informational and don't count towards your grade.</p>
                           <Cell size={6} phoneSize={2} tabletSize={2} style={{textAlign:"center"}}>
                            <Button flat style={{background:item.category!=null?"#BB0000":"#757575", color:"#FFFFFF"}}
                            onClick={()=>this.toggleViewMore(item)}
                            disabled={item.category===null}>
                            View More</Button>
                            </Cell>
                            <Cell size={3} phoneSize={2} tabletSize={2} style={{textAlign:"center"}}>
                            <Button flat style={{background:item.takeQuiz?"#005200":"#757575" , color:"#FFFFFF"}}
                            disabled={!item.takeQuiz} onClick={()=>this.takeQuizDirect(item.quiz_id, item.quiz_name,
                              item.course_id, item.section_id,item.quiz_type)}>{(item.resumeBtn === true) ? "Resume" : "Start"}</Button>
                            </Cell>
                            <Cell size={3}>
                                {item.allow_practice ? 
                                    <Button flat style={{
                                        background: item.is_finish === 1 ? this.getResumePracticeFlag(item)?"#005200":"#005200" :"#757575",
                                        color:"#FFFFFF", marginLeft:"2px"}}
                                        disabled={item.is_finish === 0}
                                    onClick={()=>this.takeQuizDirect(item.quiz_id, item.quiz_name,
                              item.course_id, item.section_id,item.quiz_type)}>{this.getResumePracticeFlag(item) === true ? "Resume Practice" :"Start Practice"}</Button> 
                                : null}
                            </Cell>
                                
                            <Cell size={12} phoneSize={2} tabletSize={4}>
                            <Table size="sm" style={{width:"80%", color:"#555", marginTop:"1rem", fontSize:"15px"}}>
                                <tr style={{
                                        textAlign:"center",
                                    }}>
                                    <th>#</th>
                                    <th>Type</th>
                                    <th>{item.quiz_type === 0 ? "Completion %" :"Score %"}</th>
                                    <th>Total Time Elapsed</th>
                                    <th>Remarks</th>
                                </tr>
                                {item.scores?.map((score) => {
                                    let scoreCompletion = score.isScoreChanged ?  score.editedScore : ((item.fullScoreIfAttempted && score.questionAttended > 0?
                                                (score.totalQuestion === score.questionAttended?
                                                    100
                                                    :  Math.round(parseFloat(score.questionAttended*100/score.totalQuestion)))
                                                :Math.round(parseFloat(score.completion_percentage)))
                                            )
                                    return <tr style={{
                                        textAlign:"center",
                                    }}>
                                        <td>{score.practice_number + 1}</td>
                                        <td>{score.practice_number === 0 ? (item.quiz_type === 0 ? "Mastery Assignment":"Test") : "Practice"}</td>
                                        <td style={{color:"#8b9dff"}}>
                                            {scoreCompletion}
                                        </td>
                                        <td style={{color:this.getTimeColor(item.time_elapsed)}}>{Utils.timeElapseDisplay(score.total_time_elapsed)}</td>
                                        <td style={{color:this.getTimeColor(item.time_elapsed)}}>{score.is_finish === 1 ? this.getStatus(score.rank) : "(In complete)"}</td>
                                    </tr>
                                })}
                                </Table>
                           </Cell>
                            <Cell size={6} phoneSize={2} tabletSize={4}>
                                <div style={{textAlign:"right"}}>
                                <b><p style={{fontSize:"larger",color:darkGray}}>{item.quiz_type === 1 ? "Score %" :"Completion %"} </p>
                                </b><br/>
                                <h1 style={{color:"#8b9dff"}}>
                                    {item.isScoreChanged ?  item.editedScore
                                    :
                                    ((item.fullScoreIfAttempted&& item.questionAttended > 0?
                                        (item.totalQuestion === item.questionAttended?
                                            100
                                            :  Math.round(parseFloat(item.questionAttended*100/item.totalQuestion)))
                                        :Math.round(parseFloat(item.completion_percentage)))
                                    )}</h1>
                                </div>
                            </Cell>
                            <Cell size={6} phoneSize={2} tabletSize={4}>
                                <div style={{textAlign:"left"}}  onClick={()=>this.showTimeStatusArray(item)}>
                                <b><p style={{fontSize:"larger",color:darkGray}}>Total Time Elapsed</p></b><br/>

                                <h1 style={{color:this.getTimeColor(item.time_elapsed)}}>{Utils.timeElapseDisplay(item.time_elapsed)}</h1>
                                <b><p id={"timeStatus"+item.indexer} style={{fontSize:"larger",color:darkGray, visibility:"hidden"}}>You are superfast</p></b>
                                </div>
                            </Cell>
                        </Grid>
                        </div>
                </Collapse>
                <Divider style={{background:"#FFFFFF"}} /> </div>
                )}
                <Divider />
                </div>
                )}

            </List>
                <div>
                Don’t see your assignments? Go to the <a href='settings'>settings page </a>
                {this.appProperties.schoolMode?'to add your standard.':'to add your course.'}
                </div>
            </center>
      </div>)}
      if(!this.state.parent){
      return (
      <div>
          {/*bug id 178 */}
          <div>
        <Button flat style={{background:"#BB0000", color:"#FFFFFF",float:"left"}}
        onClick={()=>this.toggleViewMore(selectedItem,selectedItem.indexer)}>Back</Button>
        {/*bug id 178 fixes  */}
        <h2 class="text-color-primary "style={{textAlign:"center"}}>{selectedItem.quiz_name} Statistics</h2>
      <p class="text-color-primary text-size-normal" style={{textAlign:"center"}}>{this.appProperties.schoolMode?'Standard Name:':'Course Name:'}{selectedItem.course_name} </p>
        <p class="text-color-primary text-size-normal "style={{textAlign:"center"}}>Section Name:{selectedItem.section_name}</p>

        </div>
                <Grid>
                <Cell size={6} phoneSize={2} tabletSize={4}>
                    <div style={{textAlign:"right"}}>
                    <b><p className='text-size-large' style={{color:darkGray}}>Completion % </p></b><br/>
                    <h1 style={{color:"#8b9dff"}}>{selectedItem.completion_percentage}</h1>
                    </div>
                </Cell>
                <Cell size={6} phoneSize={2} tabletSize={4}>
                    <div style={{textAlign:"left"}} onClick={()=>this.showTimeStatus(selectedItem.rank)}>
                    <b><p className='text-size-large' style={{color:darkGray}}>Total Time Elapsed</p></b><br/>
                    <h1 style={{color:selectedItem.timeColor}}>{Utils.timeElapseDisplay(selectedItem.time_elapsed)}</h1>
                    <b><p className='text-size-large' id="timeStatus" style={{color:darkGray, visibility:this.state.timeStatus}}>You are superfast</p></b>
                    </div>
                </Cell>
                </Grid>
                <Grid style = {{maxWidth : '500px'}}>
                <Cell size={12} phoneSize={4} tabletSize={8}>
                  <ProgressBar>
                  {selectedItem.category.map((element,index)=>
                  <ProgressBar bsStyle={styleArray[(index%3)]} label={`${element.value}%`} now={(element.value/selectedItem.category.length)} key={index}/>
                  )}
                  </ProgressBar>
                  </Cell>
                </Grid>
                <Divider />
                <Grid style = {{maxWidth : '500px'}}>
                <Cell size={6} phoneSize={2} tabletSize={4} style ={{marginRight:0, borderBottom:'solid 1px', borderColor :'#dee2e6'}}>
                <div  className='text-size-large' style={{color:darkGray, textAlign:"center"}}>Category</div><br/>
                {selectedItem.category.map((element,index)=>
                    <div key={index} style={{color:"#757575", borderTop:'solid 1px', borderColor :'#dee2e6', paddingLeft:5, paddingTop:10}}><b><p >{element.label != "" ? element.label : element.name}</p></b><br/></div>
                )}
                </Cell>
                <Cell size={6} phoneSize={2} tabletSize={4} style ={{marginLeft:0, borderBottom:'solid 1px', borderColor :'#dee2e6'}}>
                <div className='text-size-large' style={{color:darkGray, textAlign:"center"}}>Correct %</div><br/>
                {selectedItem.category.map((element,index)=>
                    <div key={index} style={{color:"#757575", borderTop:'solid 1px', textAlign:'center', borderColor :'#dee2e6', paddingTop:10}}>
                    <b><p className='text-size-large' >{element.value}%</p></b><br/></div>
                )}
                </Cell>
                </Grid>
      </div>
      ); }

    }
}
